<template>

  <footer>
    <el-col :span="3" :offset="2">
      <div class="">
        <dl>
          <dt>JoyOders</dt>
          <dd>
            <a href="/MerchantList">商家</a>
          </dd>
          <dd>
            <a href="/snatch">任务市场</a>
          </dd>
          <!-- <dd>
            <a href="https://bbs.joyorders.com">论坛</a>
          </dd> -->
        </dl>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="">
        <dl>
          <dt>帮助</dt>
          <dd>
            <a href="/HelpCenter?category=">常见问题</a>
          </dd>
          <dd>
            <a href="/tracktask">跟踪任务</a>
          </dd>
          <dd>
            <a @click="contact()" href="javascript:void(0)">联系我们</a>
          </dd>

        </dl>
      </div>
    </el-col>
    <el-col :span="3">
      <div class="">
        <dl>
          <dt>公司</dt>
          <dd>
            <a href="/Company">关于我们</a>
          </dd>
          <dd>
            <a href="/Company">人才招聘</a>
          </dd>
          <dd>
            <a href="/Company">合作洽谈</a>
          </dd>
        </dl>
      </div>
    </el-col>

    <el-col :span="3">
      <div class="">
        <dl>
          <dt>公众号</dt>
          <dd>
            <img src="../assets/images/homepage/addWx.jpg" height="84" width="84"/>
          </dd>
        </dl>
      </div>
    </el-col>

    <el-col :span="3">
      <div class="">
        <dl>
          <dt>小程序</dt>
          <dd>
            <img src="../assets/images/homepage/weapp.jpg" height="84" width="84"/>
          </dd>
        </dl>
      </div>
    </el-col>

    <el-col :span="4"  :offset="2" >
      <div class="">
        <dl>
          <dt>支付方式</dt>
          <dd>
            <a>
              <i class="ico ico-wechat"></i>
            </a>
            <a>
              <i class="ico ico-ali"></i>
            </a>
            <!--<a>-->
              <!--<i class="ico ico-social-paypal"></i>-->
            <!--</a>-->
          </dd>
        </dl>
      </div>
    </el-col>
    <el-col :span="24" >
      <div class="footer-details text-center"><a href="https://beian.miit.gov.cn/">沪ICP备17057454号</a> | <a href="/user-agreement">法律条款</a> | 上海悦单网络科技有限公司</div>
    </el-col>

  </footer>

</template>

<script>
  let $ = require('jQuery')
  export default {
    name: 'HelloWorld',
    data() {
      return {
        msg: 'Welcome to Your Vue.js App'
      }
    },
    methods: {
      scrolltobueyer() {
        if (this.pathname != 'home') {
          this.$router.push('/')
        }
        document.querySelector('.buyer').scrollIntoView(false)
      },
      contact () {
          this.$router.push({path:'/HelpCenter', query:{category:'contact'}})
      }
    }
  }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
  footer {
    width: 100%;
    padding-top: 80px;
    color: #9B9DA0;
    margin: 0 auto;
    max-width: 1440px;
    overflow: hidden;
    dt {
      font-size: 14px;
      color: rgba(51, 51, 51, 1);
      line-height: 20px;
      margin-bottom: 20px;
      font-weight: bold;
    }

    dd {
      margin-bottom: 20px;
      a {
        color: #9B9DA0;
        .ico {
          margin-right: 30px;
        }
      }
    }

    p {
      margin-top: 22px;
      margin-bottom: 21px;
    }
    .footer-details{
      margin: 30px 0 40px 0;
      font-family: 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica', 'Arial';
      color: #9B9DA0;

      a{
        color: #9B9DA0;
      }
    }
  }

  @media screen and (max-width: 460px) {
    footer {
      text-align: center;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Footer.vue